import jQuery from 'jquery'
import ApiGuards from '@/utils/api/ApiGuards'
import NProgress from 'nprogress'
// import ObjArrUtils from '../ObjArrUtils'
import { LetsMessageMap } from '@/components/autoImport/LetsMessage'
import AppUtils from '../AppUtils'

class ApiError extends Error {
  constructor (message) {
    super(message)
    this.name = 'ApiError'
  }

  getObject() {
    return JSON.parse(this.message)
  }

  getStatus() {
    return this.getObject().status
  }
}

function log (...args) {
  // console.log('import.meta.env.VITE_NODE_ENV',import.meta.env.VITE_NODE_ENV)
  // if (import.meta.env.VITE_NODE_ENV === 'production') {
  console.debug(...args)
  // }
}

function _error (XMLHttpRequest, textStatus, err, resolve, reject, req) {
  NProgress.done()
  _removeRequest(_requests, req)
  ApiGuards.errorGuard(XMLHttpRequest, textStatus, err, resolve, reject)
  reject(new ApiError(JSON.stringify(XMLHttpRequest)))
}


/**
 *
 * @param {*} ctx
 * @param {*} textStatus
 * @param {JQuery.jqXHR} XMLHttpRequest
 * @param {*} resolve
 * @param {*} reject
 * @param {*} req
 */
function _success (ctx, textStatus, XMLHttpRequest, resolve, reject, req) {
  NProgress.done()
  try{
    const letsVersion = XMLHttpRequest.getResponseHeader('X-Api-Version')
    window.WarnAppVersionFlag = true
    if (letsVersion) {
      if(!window.WarnAppVersionFlag &&  window.AppVersion && window.AppVersion !== letsVersion) {
        window.WarnAppVersionFlag = true
        window.vue.$dialog.notify.info(
          'ご迷惑をおかけして申し訳ございません。最新の改善を適用するため、ページを再読み込みしてください。',
          {
            position: 'bottom-right',
            timeout: 0,
            actions: {
              true: '再読み込み'
            },
          }
        ).then(ans => {
          if (ans) {
            location.reload()
          }
        })
      }

    }} catch (e) {
    console.error('Error while processing X-Api-Version header:', e)
  // Ignore error, continue processing
  }

  // handle Auth header
  try {
    const authHeader = XMLHttpRequest.getResponseHeader('X-Session-Id')
    // console.log('X-Session-Id Header:', authHeader)
    if (authHeader) {
      localStorage.setItem('X-Session-Id', authHeader)
    }
  } catch (e) {
    console.error('Error while processing X-Session-Id header:', e)
    // Ignore error, continue processing
  }

  _removeRequest(_requests, req)
  ApiGuards.successGuard(ctx, textStatus, XMLHttpRequest, resolve, reject)
  resolve(ctx.data)
}

function _removeRequest (requestArr, request) {
  const index = requestArr.indexOf(request)
  if (index > -1) {
    requestArr.splice(index, 1)
  }
}

let _requests = []

async function handleApi(promise, loadingLock=true) {
  if(loadingLock)window.vue.$store.commit('App/ADJUST_APP_LOADING', 1)
  return promise
    .catch(err => {
      let res

      // IF is not ApiError, throw error
      if (!(err instanceof ApiError)) {
        window.vue.$dialog.notify.error('System Error: ' + err.message)
        throw err
      }
      try {
        res = JSON.parse(err.message)
      } catch (e) {
        window.vue.$dialog.notify.error('Backend response is not a valid JSON. Please contact the administrator.')
        throw err
      }
      const message = (typeof res === 'object' && res.responseJSON)
        ? res.responseJSON.message
        : res
      const status = res.status ?? 0

      switch (true) {
        // for input form
        case status === 422:
          if(res.responseJSON.errorCode && res.responseJSON.errorCode === 'VALIDATION_ERROR') {
            // new

          } else{
            // old
            window.vue.$dialog.notify.error('入力エラー')
          }
          break
        case status === 400:
          window.vue.$dialog.notify.info('操作エラー: ' + message)
          break
        case status === 401:
          window.vue.$store.dispatch('Auth/Auth_logout', {
            notifyMessage: 'セッションが切れました。再度ログインしてください'
          })
          break
        case status === 403:
          window.vue.$store.dispatch('Auth/Auth_logout', {
            notifyMessage: 'セッションが切れました。再度ログインしてください'
            // notifyMessage: 'アクセス権がありません'
          })
          break
        case status === 404:
          window.vue.$dialog.notify.info('ページが見つかりません。')
          window.vue.$router.replace({ name: '404' })
          break
        case status === 408:
          window.vue.$dialog.notify.info('データリクエストがタイムアウトすると、ページが自動的に更新されます')
          setTimeout(() => {
            location.reload()
          }, 3000)
          break
        case status === 409: // conflict
          LetsMessageMap.MSG_0001.render(window.vue)
          break
        case status === 522: // ApiValidationError
          // window.vue.$dialog.error({
          //   title: 'ApiValidationError',
          //   text: '[API input validation failed.] Please check the console for more details.',
          //   actions: {
          //     true: 'OPEN IN NEW TAB'
          //   }
          // }).then(ans => {
          //   if (ans) {
          //     const content = res.responseJSON.actions
          //     // open new page as JSON
          //     const newWindow =  window.open("data:application/json," + encodeURIComponent(content),
          //       "_blank");
          //     newWindow.focus()
          //   }
          // })
          window.vue.$dialog.notify.error('システムエラー: ' + JSON.stringify(res.responseJSON.actions.errors))
          break
        case status === 599: // Custom server error
          window.vue.$dialog.notify.error('サーバーエラー:' + message)
          break
        case res.statusText === 'abort':
          // do nothing
          return
        case status === 0: // Network error
          // TODO: network error page
          window.vue.$dialog.notify.error('ネットワークエラー' + ': ' + '申し訳ありませんが、いくつかの問題が発生しました。後でもう一度やり直してください')
          break
          // show debug error message
        case AppUtils.isDebugMode():
          window.vue.$dialog.error({
            title: 'System Error システムエラー',
            text: `[${message}] \n Please check the console for more details.`,
            actions: {
              true: 'OPEN DEBUG URL'
            }
          }).then(ans => {
            if (ans) {
              const targetUrl = res.responseJSON.debug_url
              window.open(targetUrl, '_blank')
            }
          })
          console.error('Error:', res.responseJSON)
          break
          // default error message, for production
        default:
          window.vue.$dialog.notify.error('システムエラー' + ': ' + '申し訳ありませんが、いくつかの問題が発生しました。後でもう一度やり直してください')
          break
      }
      throw err
    })
    .finally(() => {
      if(loadingLock)window.vue.$store.commit('App/ADJUST_APP_LOADING', -1)
    })

}

export default {
  ApiError,
  auth: (ctx, loading = true) => {
    return new Promise((resolve, reject) => {
      // Sets the url and prepare the data
      const url = window.API_URL + 'auth.api'
      const json = JSON.stringify(ctx, null, 2)

      // Pre-send Processing / Guard
      ApiGuards.preSendGuard(url, ctx, resolve, reject)

      // If nprogress loading is enabled
      if (loading) NProgress.start()

      // AJAX Request
      const req = jQuery.ajax({
        url,
        type: 'POST',
        data: json,
        headers: {
          'X-Frontend-URL': window.location.origin + window.location.pathname
        },
        xhrFields: {
          withCredentials: true
        },
        error: (XMLHttpRequest, textStatus, err) => {
          _error(XMLHttpRequest, textStatus, err, resolve, reject, req)
        },
        success: (ctx, textStatus, XMLHttpRequest) => {
          _success(ctx, textStatus, XMLHttpRequest, resolve, reject, req)
        }
      })
      _requests.push(req)
    })
  },
  getData: (api, params, loading = true) => {
    return new Promise((resolve, reject) => {
      // Sets the url and prepare the data
      let url = window.API_URL + 'data.api?api=' + api
      if (params) {
        params.forEach(function (val, key) {
          url = url + key + '=' + val
        })
      }

      // Pre-send Processing / Guard
      ApiGuards.preSendGuard(url, {}, resolve, reject)

      // If nprogress loading is enabled
      if (loading) NProgress.start()

      // AJAX Request
      const req = jQuery.ajax({
        url,
        dataType: 'jsonp',
        headers: {
          'X-Frontend-URL': window.location.origin + window.location.pathname
        },
        xhrFields: {
          withCredentials: true
        },
        error: (XMLHttpRequest, textStatus, err) => {
          _error(XMLHttpRequest, textStatus, err, resolve, reject, req)
        },
        success: (res, textStatus, XMLHttpRequest) => {
          const ctx = res.data[''].output
          _success(ctx, textStatus, XMLHttpRequest, resolve, reject, req)
        }
      })
      _requests.push(req)
    })
  },
  postData: (ctx, loading = true) => {
    return handleApi(new Promise((resolve, reject) => {
      // Sets the url and prepare the data
      const url = window.API_URL + 'data.api'
      const json = JSON.stringify(ctx, null, 2)

      // Pre-send Processing / Guard
      ApiGuards.preSendGuard(url, ctx, resolve, reject)

      // If nprogress loading is enabled
      NProgress.start()

      // AJAX Request
      log('Sending',ctx)
      const req = jQuery.ajax({
        url,
        type: 'POST',
        data: json,
        headers: {
          'X-Frontend-URL': window.location.origin + window.location.pathname
        },
        xhrFields: {
          withCredentials: true
        },
        error: (XMLHttpRequest, textStatus, err) => {
          log('Error', XMLHttpRequest)
          _error(XMLHttpRequest, textStatus, err, resolve, reject, req)
        },
        success: (ctx, textStatus, XMLHttpRequest) => {
          _success(ctx, textStatus, XMLHttpRequest, resolve, reject, req)
          log('Receive',ctx)
        }
      })
      _requests.push(req)
    }),loading)
  },
  upload: (ctx, loading = true) => {
    console.log(ctx)
    return new Promise((resolve, reject) => {
      // Sets the url and prepare the data
      const url = window.API_URL + 'upload.api'
      const formData = new FormData()
      formData.append('file', ctx, ctx.name)

      // AJAX Request
      const req = jQuery.ajax({
        url,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'X-Session-Id': localStorage.getItem('X-Session-Id') || null,
        },
      }).then(response => {
        const reader = new FileReader()
        reader.onload = () => resolve({
          ...response,
          url: reader.result
        })
        reader.onerror = reject
        reader.readAsDataURL(ctx)
      })
      _requests.push(req)
    })
  },
  download: (ctx) => {
    console.log(ctx)
    return new Promise((resolve, reject) => {
      // Sets the url
      const url = window.API_URL + 'download.api'

      // Sets a hidden send form element
      const sendForm = document.createElement('form')
      sendForm.action = url
      sendForm.method = 'POST'
      sendForm.style.visibility = 'hidden'
      sendForm.target = 'download'
      document.body.appendChild(sendForm)

      // Sets form data and send to download
      const fld1 = document.createElement('input')
      fld1.name = 'data'
      fld1.type = 'hidden'
      fld1.value = JSON.stringify(ctx)
      sendForm.appendChild(fld1)
      sendForm.submit()
    })
  },
  abortAll: () => {
    _requests.forEach((request) => {
      request.abort()
    })
    _requests = []
  }
}
